import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import {
  issueAttributesType,
  issueTransitionType,
  oxygenType,
} from '../../../../constants/proptype-validation';
import IssuePreviewTransitionPopUpForm from './components/IssuePreviewTransitionPopUpForm';
import IssuePreviewNoWorkflowConfiguration from '../../../IssuePreviewNoWorkflowConfiguration';
import { getPermittedStatuses } from '../../../../utils/issues-helpers';
import { getIsWorkflowMisconfigured } from '../../../../utils/workflow';

class IssuePreviewTransitionPopUp extends PureComponent {
  isTransitionMisconfigured() {
    const { issue, pendingTransition, oxygen } = this.props;
    const transition = getPermittedStatuses(issue).find(
      (permittedTransition) => permittedTransition.serverStatus === pendingTransition.value
    );
    return getIsWorkflowMisconfigured(transition, oxygen);
  }

  renderForm() {
    const {
      issue,
      changeToStatus,
      pendingTransition,
      transitionFields,
      closePopup,
      onStatusChange,
      onToggleCreateRevision,
      closeIssuePreview,
      showCreateRevisionField,
    } = this.props;
    return (
      <IssuePreviewTransitionPopUpForm
        issue={issue}
        changeToStatus={changeToStatus}
        pendingTransition={pendingTransition}
        transitionFields={transitionFields}
        closePopup={closePopup}
        onStatusChange={onStatusChange}
        onToggleCreateRevision={onToggleCreateRevision}
        showCreateRevisionField={showCreateRevisionField}
        closeIssuePreview={closeIssuePreview}
      />
    );
  }

  renderContent() {
    const { changeToStatus, transitionFields, closePopup } = this.props;
    if (!changeToStatus) {
      return null;
    }
    const showInsufficientConfigurationPopup = this.isTransitionMisconfigured();
    if (showInsufficientConfigurationPopup) {
      return <IssuePreviewNoWorkflowConfiguration closePopup={closePopup} />;
    }
    return isEmpty(transitionFields) ? null : this.renderForm();
  }

  render() {
    const { changeToStatus } = this.props;
    const divClassNames = cx('IssuePreviewTransitionPopUp', {
      open: changeToStatus,
    });
    return (
      <div className={divClassNames} data-testid="IssuePreviewTransitionPopUp">
        {this.renderContent()}
      </div>
    );
  }
}

IssuePreviewTransitionPopUp.displayName = 'IssuePreviewTransitionPopUp';

IssuePreviewTransitionPopUp.propTypes = {
  issue: issueAttributesType.isRequired,
  changeToStatus: PropTypes.string.isRequired,
  pendingTransition: issueTransitionType.isRequired,
  transitionFields: PropTypes.array,
  closePopup: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onToggleCreateRevision: PropTypes.func.isRequired,
  oxygen: oxygenType.isRequired,
  closeIssuePreview: PropTypes.func.isRequired,
  showCreateRevisionField: PropTypes.bool.isRequired,
};
IssuePreviewTransitionPopUp.defaultProps = {
  transitionFields: [],
};
export default IssuePreviewTransitionPopUp;
